require('./scheduleService');
require('../favorites/favoritesService');

angular.module('app.schedule.scheduleController', [
  'app.schedule.scheduleService',
  'app.favorites.favoritesService'
])
  .controller('app.schedule.scheduleController', [
    '$scope', 'app.schedule.scheduleService', '$stateParams', '$rootScope', 'app.favorites.favoritesService',
    function ($scope, scheduleService, $stateParams, $rootScope, favoritesService) {
      'use strict';

      $scope.searchInclude = $scope.searchInclude || false;
      $scope.searchHideDateSelector = $scope.searchHideDateSelector || false;
      $scope.searchHide = $scope.searchHide || false;
      $scope.searchHideTerm = $scope.searchHideTerm || false;
      $scope.searchName = $scope.searchName || null;
      $scope.broadcastActive = $scope.broadcastActive || false;
      $scope.limitToFavorites = (typeof $scope.limitToFavorites === 'undefined' || false);
      $scope.favoritesService = favoritesService;

      let schedule_params = {
        limit_favorites: $scope.limitToFavorites
      };

      if ($stateParams.search) {
        schedule_params.type = $stateParams.search.type;
        schedule_params.search_id = $stateParams.search.search_id;
      }

      if ($stateParams.type && $stateParams.id) {
        schedule_params.type = $stateParams.type;
        schedule_params.search_id = $stateParams.id;
        $scope.searchInclude = false;
      }


      $scope.active_favorite = null;
      $scope.isScheduleHidden = false;

      let init = function () {
        let params;

        $scope.schedule = scheduleService.schedule;
        $scope.schedule.reset_params();

        $scope.scheduleType = $scope.scheduleType || null;
        if ($scope.scheduleType === 'my_games') {
          $scope.schedule.merge_params(
            {
              date_disabled: true,
              my_games: true,
              limit_favorites: false,
              sort: "desc"
            }
          );
        }

        $scope.schedule.isUpcomingSchedule($scope.scheduleType === 'upcoming_schedule');

        $scope.schedule.current_page = 1;

        if ($stateParams.scheduleSearch) {
          let params = JSON.parse($stateParams.scheduleSearch);
          if(!_.isEmpty(params.favorites)) {
            favoritesService.selected = params.favorites;
          }

          $scope.schedule.retrieve(params)
            .then(() => {
              $scope.$broadcast('reinit_schedule_search');
            });
        } else {
          if ($scope.searchTerm) {
            params = angular.merge(
              {date_disabled: true},
              $scope.searchTerm
            );

          } else {
            params = null;
          }

          if (!$scope.searchInclude) {
            favoritesService.clear();
            $scope.schedule.retrieve(params);
          } else if ($stateParams.selected_favorites) {
            let serviceFavorite = parseInt(favoritesService.selected[0]);
            let selectedFavorite = parseInt($stateParams.selected_favorites.id);
            if (serviceFavorite !== 10 || serviceFavorite !== selectedFavorite) {
              favoritesService.selected.splice(0, 1);
            }

            favoritesService.toggle_selected($stateParams.selected_favorites.id);
          } else {
            $scope.schedule.retrieve();
          }
        }
      };

      $scope.is_expandable = function (game) {
        return !game.is_blacked_out;
      };
      $scope.toggle_collapsed = function (game, is_collapsed) {
        if (!$scope.is_expandable(game)) {
          is_collapsed = true;
        } else {
          is_collapsed = !is_collapsed;
        }
        return is_collapsed;
      };

      $scope.onShowFavorites = (game) => {
        game.favoritesOpen = !game.favoritesOpen;

      };

      $scope.gamePeriodSuffix = function (period, time) {
        period = period.toLowerCase();

        switch (period) {
          case 'pre':
            period = 'pregame';
            break;
          case '1':
            period = period + 'st';
            break;

          case '2':
            period = period + 'nd';
            break;

          case '3':
            period = period + 'rd';
            break;

          case '4':
            period = period + 'th';
            break;

          case 'final':
            break;
        }

        if (period !== 'pregame' && period !== 'final') {
          period = period + ' ' + time;
        }

        return period;
      };

      $scope.get_game_timeperiod = function (game) {
        if (game.overlay) {
          game.overlay.timeperiod = $scope.gamePeriodSuffix(game.overlay.strperiod, game.overlay.strtime);

          return game.overlay.timeperiod;
        }
      };

      $scope.$on('favorites_selected', function () {
        let params = {};

        if($scope.schedule.current_params && $scope.schedule.current_params.type) {
          params.search_id = null;
          params.type = null;
          params.search_term = null;
        }

        $scope.schedule.current_page = 1;
        $scope.schedule.retrieve(params, {saveToHistory: true});
      });

      $rootScope.$on('schedule_search_select_term', function () {
        $scope.schedule.current_page = 1;
      });

      $scope.$on(
        'scheduleSearchTermVisibilityChanged',
        /**
         * @param event
         * @param {*} data
         */
        function (event, data) {
          $scope.isScheduleHidden = data.isVisible;
        }
      );

      $scope.$on('$destroy', function () {
        $scope.schedule.reset_params();
      });

      return init();
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/schedule/scheduleController.js